import { instance, endpoint, isMockLogin, generator } from 'api'
import { mocker } from 'api/autologin/mocker'

export default {
  getAutoLoginParams (runno) {
    if (isMockLogin) return generator(mocker.autoLoginParams())
    return instance().get(endpoint + '/autologin/' + runno)
  }
}



// WEBPACK FOOTER //
// ./src/api/autologin/index.js